import React from "react";
import { FormattedMessage } from "react-intl";

import { DeviceNameCell } from "../../../../../components/table";
import { DeviceWithType } from "../../../../../components/devices/DeviceWithType";
import { singleDeviceIdSort } from "../../../../../components/table/helpers/sorting.helper";
import { Manufacturer } from "../../../../../components/manufacturer/Manufacturer";
import { RequestedDevicesDropdownActions, TableCard } from "./components";

export const COLUMNS = [
  {
    Header: <FormattedMessage id={"device_name_devices_table_header"} />,
    accessor: "name",
    sortable: true,
    Cell: ({
      row: {
        original: { name },
      },
    }) => <DeviceNameCell name={name} />,
  },
  {
    Header: <FormattedMessage id={"device_id_devices_table_header"} />,
    accessor: "id",
    sortable: true,
    Cell: ({
      row: {
        original: { id, type },
      },
    }) => <DeviceWithType type={type} identifier={id} />,
    sortType: singleDeviceIdSort,
  },
  {
    Header: <FormattedMessage id={"manufacturer_devices_table_header"} />,
    accessor: "manufacturer",
    sortable: true,
    cellClassName: "color-table__cell",
    Cell: ({
      row: {
        original: { manufacturer },
      },
    }) => <Manufacturer manufacturer={manufacturer} />,
  },
  {
    Header: <FormattedMessage id={"actions"} />,
    id: "actions",
    sortable: false,
    headerClassName: "table__cell--small-cell",
    cellClassName: "table__cell--center table__cell--overflow",
    Cell: ({
      row: {
        original: { id, name, type },
      },
    }) => (
      <RequestedDevicesDropdownActions
        identifier={id}
        name={name}
        type={type}
      />
    ),
  },
];

export const COLUMNS_MOBILE = [
  {
    accessor: "name",
    cellClassName: "table__cell--overflow",
    SortingLabel: <FormattedMessage id={"device_name_devices_table_header"} />,
    Cell: ({
      row: {
        original: { name, id, manufacturer, type },
      },
    }) => (
      <TableCard
        type={type}
        identifier={id}
        manufacturer={manufacturer}
        name={name}
      />
    ),
  },
  {
    accessor: "id",
    SortingLabel: <FormattedMessage id={"device_id_devices_table_header"} />,
    sortType: singleDeviceIdSort,
  },
  {
    accessor: "manufacturer",
    SortingLabel: <FormattedMessage id={"manufacturer_devices_table_header"} />,
  },
];

export const SEARCH_KEYS = ["id", "manufacturer", "name"];
